import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import SubPage from "../components/SubPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		groups: state.data.groups,
		lang: state.data.lang,
		auth: state.data.auth,
		rank: state.data.userInfo.rank,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const SubPageContainer = connect(mapStateToProps, mapDispatchToProps)(SubPage);

export default SubPageContainer;


// WEBPACK FOOTER //
// ./src/containers/SubPageContainer.js